module.exports = __webpack_public_path__ + "img/l-hd.d6ae64fe.webp";